import React from "react";
import Grafica from "./Grafica";
import styled, { css } from 'styled-components/macro';
import { percentToAbs } from "../../utils/fmtUtils";
import { themes } from "../../styles/themes";
import { fmt } from '../../utils'

const GraficaDonut = props => {
	console.log(props)
	return (
		<Grafica
				option={optionDonut(props)}
				css={`
					width: 100%;
					height: 400px;
				`}
			/>
	)
}

const optionDonut = ({value, color, name, isDialog=false}) => {
	const absValue = percentToAbs(value);
	const data = getData(absValue, color, name);

	const option = {
    tooltip: {
      trigger: "item",
      confine: true,
      padding: 0,
    },
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: true,
        label: {
          color: '#000',
          fontSize: isDialog ? '20' : '35',
          position: 'center',
          formatter: () => {
            return absValue.replace('.',',') + '%' || "0%"; 
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
				animation:true
      },
    ],
  };
	return option
}


function getData(value, color, name){
	const parsedData = [];
	const sinAsignar = {
		value: 100 - Number(value),
		itemStyle:{
			color: themes.color.sinAsignar,
			shadowColor:themes.color.sinAsignar,
			shadowBlur: 5,
			shadowOffsetY: 5,
			borderType: 'solid',
			opacity: 0.8
		},
		tooltip:{
			show: false
		}
	};

	const data = {
    name: name,
    value: value,
		itemStyle:{
			color: color,
			shadowColor:color,
			shadowBlur: 5,
			shadowOffsetY: 5,
			borderType: 'solid',
			opacity: 0.8
		},
		tooltip:{
			show: false
		},
    emphasis: {
      show: false,
      itemStyle: {
        borderColor: color,
        color: color,
      },
    },
  }
	parsedData.push(sinAsignar);
	parsedData.push(data);
	return parsedData;
}

export default GraficaDonut;